var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useAuthProvider, useDependency, useGetWorkspaceSsoLoginParams, } from '@lucidlink/workspacemanagement';
export const useStartSsoAuthentication = (initializeAuthentication) => {
    _react_refresh_temp_1();
    const { workspaceId = '' } = useParams();
    const { currentUser } = useAuthProvider();
    const { data: ssoLoginParams } = useGetWorkspaceSsoLoginParams(workspaceId);
    const clientBaseUrl = useDependency('CLIENT_BASE_URL');
    const startSSOAuthentication = useCallback(async () => {
        if (!ssoLoginParams) {
            return;
        }
        await initializeAuthentication({
            clientId: ssoLoginParams.clientId,
            serverUri: ssoLoginParams.openIdConnectUrl,
            redirectUri: `${clientBaseUrl}/sso-landing`,
            loginHint: currentUser?.email || '',
        });
    }, [
        ssoLoginParams,
        initializeAuthentication,
        clientBaseUrl,
        currentUser?.email,
    ]);
    return startSSOAuthentication;
};
_react_refresh_temp_1(useStartSsoAuthentication, "omBOhJtUNZBUwGrmk6nQADZ6Ruo=", false, () => [useParams, useAuthProvider, useGetWorkspaceSsoLoginParams, useDependency]);
